export default __webpack_public_path__ + "static/media/hht2_home_img_EP3.52e08534.png";